export { default as LoyaltyBackground } from './loyalty-background';
